import { MOCK_SITE_SAMPLE_IDS } from "./constants";


var requestCount = 0
var counter = 0
var showModal = true

export const getNotificationList = (site) => {
  if (site == MOCK_SITE_SAMPLE_IDS.notification_backup) {
    requestCount += 1
    if (requestCount % 3 == 0) {
      counter = counter >= 5 ? 0 : counter + 1
      showModal = true
    }
    else {
      showModal = false
    }
    return getNotifications().slice(0, 3);
  }
  return [];
};

export const getNotificationDetails = (site, id) => {
  return getNotifications().find((item) => item.id === id);
};

const one_day = 60 * 60 * 24
const now = (Date.now() / 1000)
const expiry = (Date.now() / 1000) + 24 * 60 * 60

const randomTime = () => {
  return Math.round(Math.random() * 86400)
}

const getNotifications = () => {

  return [
    {
      id: "96811b10-86e0-49f0-83f6-4bf7736b0f62",
      timestamp: now - one_day * 4 + 60,
      acknowledged: now - one_day * 3,
      severity: "warning",
      title: "Solar generation",
      name: "Solar generation not detected",
      description:
        "Solar generation has not been detected in over 3 days and may indicate an issue requiring investigation by your installer.",
      links: [
        {
          "name": "Troubleshooting faults",
          "path": "faq/faults",
          "target": "website",
          "url": "https://empowerenergy.com.au/faq/faults",
          "external": true
        },
      ],
      priority: counter == 3 ? 10 : 15,
      channels: {
        push: { expiry: expiry },
        home: { expiry: expiry },
        modal: { expiry: showModal ? expiry : now },
        history: { expiry: expiry },
      },
    },
    {
      id: "96811b10-86e0-49f0-83f6-4bf7736b0f63",
      timestamp: now - 60 * 40,
      resolved: counter > 0 ? now - 60 * 8 : null,
      severity: "notice",
      title: "Home backup",
      name: "Home backup active",
      description:
        "Your battery is currently providing backup electricity to your home because the grid connection is unavailable.",
      resolved_name: "Grid connection restored - backup completed",
      resolved_description: "Your battery has provided backup electricity to your home. The grid connection has now been restored.",
      links: [
        {
          "name": "Your battery for home backup",
          "path": "faq/backup",
          "target": "website",
          "url": "https://empowerenergy.com.au/faq/backup",
          "external": true
        },
        {
          "name": "Change reserve settings",
          "path": "settings",
          "target": "website",
          "url": "/settings",
          "external": false
        },
      ],
      priority: counter <= 2 ? 10 : 15,
      channels: {
        push: { expiry: expiry },
        home: { expiry: expiry },
        modal: { expiry: showModal ? expiry : now },
        history: { expiry: expiry },
      },
    },
    {
      id: "96811b10-86e0-49f0-83f6-4bf7736b0f64",
      timestamp: now - one_day * 7 + randomTime(),
      severity: "warning",
      title: "Update network connection",
      name: "4G backup - connectivity limited",
      description:
        "Your battery is currently running on 4G backup for internet connectivity. Update WIFI details to maintain full operation of the battery.",
      resolved_name: "WIFI connection restored",
      resolved_description:
        "WIFI network connection has now been restored.",
      links: [
        {
          "name": "Update WIFI settings",
          "path": "/settings",
          "target": "app",
          "url": "/settings",
          "external": false
        },
      ],
      priority: counter == 4 ? 10 : 15,
      channels: {
        home: { expiry: expiry },
        modal: { expiry: showModal ? expiry : now },
        history: { expiry: expiry },
      },
    },
    {
      id: "96811b10-86e0-49f0-83f6-4bf7736b0f65",
      timestamp: now - one_day * 2 + randomTime(),
      severity: "informational",
      category: "recommendation",
      event: "empoweriq_recommendation_activate",
      title: "EmpowerIQ",
      name: "Could you save more with a different electricity plan + EmpowerIQ?",
      description: "Choosing an electricity plan that matches your usage is often one of the fastest ways to maximise the return on your battery investment.",
      data: {
        "recommendation_savings": 684,
        "recommendation_old_cost": 1627,
        "recommendation_new_cost": 943,
        "recommendation_price_reference": 0.42,
        "recommendation_days": 64,
        "recommendation_plan_summary": "EmpowerIQ recommends you consider a time-of-use electricity plan with a free period in the middle of the day.",
        "recommendation_plan_detail": "Electricity plans with free midday periods may suit your usage. These plans typically provide a window of free electricity in the middle of the day, which can be used to power your home and charge your battery. Stored energy can then be used during higher-priced periods later in the day. Examples of these plans include OVO’s Free 3 and GloBird Energy’s Zero Hero and Free Lunch. When used alongside EmpowerIQ optimisation, these plans may help improve the overall performance of your Elektrobank system."
      },
      links: [
        {
          "name": "Add your electricity plan details",
          "path": "settings/savings-maximiser",
          "target": "app",
          "url": "/settings/savings-maximiser",
          "external": false
        },
      ],
      priority: 1,//counter == 5 ? 10 : 15,
      channels: {
        home: { expiry: expiry },
        modal: { expiry: showModal ? expiry : now },
        history: { expiry: expiry },
      },
    },
    {
      id: "96811b10-86e0-49f0-83f6-4bf7736b0f66",
      timestamp: now - one_day * 2 + randomTime(),
      severity: "informational",
      category: "recommendation",
      event: "empoweriq_recommendation_activate",
      title: "EmpowerIQ",
      name: "Could you save more with a different electricity plan + EmpowerIQ?",
      description: "Choosing an electricity plan that matches your usage is often one of the fastest ways to maximise the return on your battery investment.",
      data: {
        "recommendation_savings": 684,
        "recommendation_old_cost": 1627,
        "recommendation_new_cost": 943,
        "recommendation_price_reference": 0.42,
        "recommendation_days": 64,
        "recommendation_plan_summary": "EmpowerIQ recommends considering a plan that passes on variable wholesale energy rates, using our EmpowerIQ for Amber integration.",
        "recommendation_plan_detail": "Electricity plans that follow wholesale market prices (such as those available through our Amber integration) give EmpowerIQ the flexibility to use your battery more effectively. This allows us to automatically choose the best times to buy electricity when prices are low and sell energy back to the grid when prices are higher—maximising your potential savings."
      },
      links: [
        {
          "name": "Add your electricity plan details",
          "path": "settings/savings-maximiser",
          "target": "app",
          "url": "/settings/savings-maximiser",
          "external": false
        },
      ],
      priority: 1,//counter == 5 ? 10 : 15,
      channels: {
        home: { expiry: expiry },
        modal: { expiry: showModal ? expiry : now },
        history: { expiry: expiry },
      },
    },
    {
      id: "96811b10-86e0-49f0-83f6-4bf7736b0f67",
      timestamp: now - one_day * 2 + randomTime(),
      severity: "informational",
      category: "recommendation",
      event: "empoweriq_recommendation_change_plan",
      title: "EmpowerIQ",
      name: "Could you save more with a different electricity plan?",
      description: "Choosing an electricity plan that matches your usage is often one of the fastest ways to maximise the return on your battery investment.",
      data: {
        "recommendation_savings": 684,
        "recommendation_old_cost": 1627,
        "recommendation_new_cost": 943,
        "recommendation_days": 64,
        "recommendation_plan_summary": "EmpowerIQ recommends considering a plan that passes on variable wholesale energy rates, using our EmpowerIQ for Amber integration.",
        "recommendation_plan_detail": "Electricity plans that vary with wholesale market changes, allow EmpowerIQ to use your battery to find the best time and price to buy and sell energy for your home."
      },
      links: [
        {
          "name": "Update your electricity plan details",
          "path": "settings/savings-maximiser?action=upload-plan",
          "target": "app",
          "url": "/settings/savings-maximiser?action=upload-plan",
          "external": false
        },
      ],
      priority: counter == 5 ? 10 : 15,
      channels: {
        home: { expiry: expiry },
        modal: { expiry: showModal ? expiry : now },
        history: { expiry: expiry },
      },
    },
    {
      id: "96811b10-86e0-49f0-83f6-4bf7736b0f68",
      timestamp: now - one_day * 2 + randomTime(),
      severity: "informational",
      category: "recommendation",
      event: "empoweriq_recommendation_provide_plan",
      title: "EmpowerIQ",
      name: "Add your electricity plan details",
      description: "Provide your current electricity plan details so EmpowerIQ can accurately track your electricity costs and help you save money.",
      links: [
        {
          "name": "Add your electricity plan details",
          "path": "settings/savings-maximiser?action=upload-plan",
          "target": "app",
          "url": "/settings/savings-maximiser?action=upload-plan",
          "external": false
        },
      ],
      priority: counter == 5 ? 10 : 15,
      channels: {
        home: { expiry: expiry },
        modal: { expiry: showModal ? expiry : now },
        history: { expiry: expiry },
      },
    },
    {
      id: "96811b10-86e0-49f0-83f6-4bf7736b0f69",
      timestamp: now - one_day * 2 + randomTime(),
      severity: "informational",
      category: "recommendation",
      event: "empoweriq_recommendation_check_plan",
      title: "EmpowerIQ",
      name: "Has your electricity plan changed?",
      description: "If your plan or rates change, let us know so EmpowerIQ can continue optimising your energy savings correctly.",
      links: [
        {
          "name": "Update your electricity plan details",
          "path": "settings/savings-maximiser?action=upload-plan",
          "target": "app",
          "url": "/settings/savings-maximiser?action=upload-plan",
          "external": false
        },
      ],
      priority: counter == 5 ? 10 : 15,
      channels: {
        home: { expiry: expiry },
        modal: { expiry: showModal ? expiry : now },
        history: { expiry: expiry },
      },
    },
  ];

}